import { render, staticRenderFns } from "./service.vue?vue&type=template&id=869d3e40&scoped=true&"
import script from "./service.vue?vue&type=script&lang=ts&"
export * from "./service.vue?vue&type=script&lang=ts&"
import style0 from "./service.vue?vue&type=style&index=0&id=869d3e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869d3e40",
  null
  
)

export default component.exports